module.exports = __webpack_public_path__ + "img/zzquant.3436fe8c.jpg";